import { createSlice } from "@reduxjs/toolkit";

export const ADD_VEHICLE = "addVehicle";
export const CURRENT_VEHICLE_INDEX = "currentVehicleIndex";
export const VEHICLES = "vehicles";
export const SELECTED_VEHICLE = "selectedVehicle";

const initialState = {
  [ADD_VEHICLE]: 1,
  // TODO: load user account data dynamically
  [VEHICLES]: [],
  [SELECTED_VEHICLE]: {},
  [CURRENT_VEHICLE_INDEX]: 0,
};

export const vehicleSlice = createSlice({
  name: "vehicle",
  initialState,
  reducers: {
    setAddVehicle: (state, action) => {
      state.addVehicle = action.payload.addVehicle;
    },
    addVehicleData: (state, action) => {
      const { index, data } = action.payload;
      if (state.vehicles[index]) {
        state.vehicles[index] = { ...state.vehicles[index], ...data };
      } else {
        state.vehicles[index] = data;
      }
    },
    updateVehicleData: (state, action) => {
      const { index, data } = action.payload;
      if (state.vehicles[index]) {
        state.vehicles[index] = { ...state.vehicles[index], ...data };
      }
    },
    setVehicleIndex: (state, action) => {
      state[CURRENT_VEHICLE_INDEX] = action.payload.vehicleIndex;
    },
    setSelectedVehicle: (state, action) => {
      state[SELECTED_VEHICLE] = action.payload.selectedVehicle;
    },
    setVehicles: (state, action) => {
      state[VEHICLES] = action.payload.vehicles;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setAddVehicle,
  addVehicleData,
  updateVehicleData,
  setVehicleIndex,
  setSelectedVehicle,
  setVehicles,
} = vehicleSlice.actions;

export const getVehicleSliceData = (state, key) => {
  return state.vehicle[key];
};

export const getVehicleDetails = (state, index) => {
  return state.vehicle.vehicles[index];
};

export default vehicleSlice.reducer;
